import React, { useState, useEffect } from 'react'
import { Row, Col, Container, Dropdown, Nav, Tab, OverlayTrigger, Tooltip, Button, Modal, ModalFooter, Form } from 'react-bootstrap'
import Card from '../Card'
import { Link, useNavigate, Route } from 'react-router-dom'
import { handleImageUpload } from "../../api/uploads";
import { apiHandler } from '../../api/apihandler';
import { GROUP_CREATE, GROUP_PROFILE_IMAGE } from '../../api/constants'
import Swal from 'sweetalert2';
import Cropper from 'react-easy-crop'
import LoaderModal from '../loaderModal'

// Redux Selector / Action
import { useDispatch, useSelector } from 'react-redux';

import getCroppedImg from '../../utilities/crop-image'
//import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import img7 from '../../assets/images/page-img/profile-bg7.jpg'

const CreateNewGroup = ({ getGroupListApi }) => {
    let profileData = (useSelector((state) => state.setting.setting.user_data))
    profileData = profileData ? JSON.parse(profileData) : "";

    const [showCreateGroup, setShowCreateGroup] = useState(false);
    const [profileImage, setProfileImage] = useState('')
    const [groupName, setGroupName] = useState('')
    const [showLoader, setShowLoader] = useState(false);

    const [crop, setCrop] = useState({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [showCroper, setShowCroper] = useState(false)
    const [imageForCrop, setImageForCrop] = useState("")
    const [croppedImage, setCroppedImage] = useState("")
    const [rotation, setRotation] = useState(0)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)

    const handleShowCroper = () => {
        setShowCroper(true)
    }
    const handleCloseCroper = () => {
        setShowCroper(false)
    }

    const resizeComplete = async () => {
        await onCropComplete()
        await showCroppedImage()
    }
    const onCropComplete = async (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels)
    }

    const showCroppedImage = async () => {
        try {
            const croppedImage1 = await getCroppedImg(
                imageForCrop,
                croppedAreaPixels,
                rotation
            )
            //console.log(croppedImage)
            //handleUpload(croppedImage)
            setCroppedImage(croppedImage1)
            setProfileImage(URL.createObjectURL(croppedImage1))
            handleCloseCroper()
        } catch (e) {
            console.error(e)
        }
    }

    const handleUpload = async (file) => {
        setShowCreateGroup(false)
        setShowLoader(true)
        try {
            const fileCon = new File([file], `cropped-image.jpg`, { type: 'image/jpeg' });
            const url = await handleImageUpload(fileCon, "feedImages/", "image/jpeg")
            createNewGroupApi(url)
        } catch (error) {
            console.error('Error uploading image:', error);
        }
    };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        event.target.value = "";
        if (file) {
            const reader = new FileReader();
            reader.onloadend = async () => {
                handleShowCroper()
                setImageForCrop(reader.result)
            };
            reader.readAsDataURL(file);
        }
    };

    useEffect(() => {
    }, [])

    async function createNewGroupApi(url) {
        try {
            const res = await apiHandler(GROUP_CREATE, 'POST', {
                name: groupName,
                //path: url
            });
            if (res.data?.response?.status === 200) {
                groupProfileImageUpload(url, res?.data?.data?.group?.id)
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.response?.data?.data?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
        }
    }

    async function groupProfileImageUpload(url, id) {
        try {
            const res = await apiHandler(GROUP_PROFILE_IMAGE, 'POST', {
                group_id: id,
                path: url
            });
            if (res.data?.response?.status === 200) {
                setShowLoader(false)
                getGroupListApi()
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.response?.data?.data?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        } finally {
        }
    }

    return (
        <>
            <LoaderModal showLoader={showLoader}/>
            <Card id="post-modal-data">
                <Card.Header className="d-flex justify-content-between">
                    <div className="header-title">
                        <h4 className="card-title">Create New Group</h4>
                    </div>
                </Card.Header>
                <Card.Body>
                    <div className="d-flex align-items-center">
                        <div className="user-img">
                            <img src={profileData?.user_setting?.photo ? profileData?.user_setting?.photo :
                                "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="userimg" className="avatar-60 rounded-circle" />
                        </div>
                        <form className="post-text ms-3 w-100 " onClick={() => (setShowCreateGroup(true))}>
                            <input type="text" className="form-control rounded" placeholder="Group Name here..." style={{ border: "none" }} />
                        </form>
                    </div>
                </Card.Body>
                {/* Redesigned from a bare, left-aligned avatar sitting in an
                    otherwise-empty row (the image drifted to the left with a
                    huge dead gap beside it) and a half-width name field with
                    nothing filling the other half - both artifacts of the
                    layout having no centering/full-width intent behind them,
                    not a deliberate narrow design. Centered avatar with a
                    clearer "add a photo" affordance, a full-width name field
                    with an icon and helper text, and a submit button that's
                    disabled until both required fields are actually filled
                    in (matching the existing name+image-required validation
                    below) instead of only complaining after the click. */}
                <Modal show={showCreateGroup} onHide={() => (setShowCreateGroup(false))} centered contentClassName="rounded-4">
                    <Modal.Header closeButton className="border-0 pb-0">
                        <Modal.Title className="d-flex align-items-center gap-2">
                            <span className="d-inline-flex align-items-center justify-content-center rounded-circle bg-soft-primary text-primary" style={{ width: 40, height: 40, flexShrink: 0 }}>
                                <i className="material-symbols-outlined">group_add</i>
                            </span>
                            <span className="fw-bold" style={{ fontSize: 18 }}>Create New Group</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="pt-2 pb-4">
                        <Form.Group className="form-group text-center mb-4">
                            <div className="profile-img-edit mx-auto" style={{ height: 120, width: 120 }}>
                                <img className="profile-pic" style={{ height: 120, width: 120, objectFit: "cover", border: "3px solid var(--bs-white)", boxShadow: "0 0 0 1px rgba(0,0,0,.08)" }}
                                    src={profileImage ? profileImage : "https://uzone360live.s3.amazonaws.com/noimage.png"} alt="profile-pic" />
                                <div className="p-image" style={{ height: 34, width: 34, lineHeight: "32px", border: "2px solid var(--bs-white)" }}>
                                    <label htmlFor="imageUpload1" className="m-0">
                                        <i className="ri-camera-fill upload-button text-white" style={{ fontSize: 16 }} alt="preview image" />
                                    </label>
                                    <input className="file-upload"
                                        id="imageUpload1" type="file" accept="image/*"
                                        //multiple="multiple"
                                        onChange={
                                            handleImageChange
                                        }
                                    />
                                </div>
                            </div>
                            <p className="text-muted small mb-0 mt-2">Add a group photo</p>
                        </Form.Group>
                        <Form.Group className="form-group mb-1">
                            <Form.Label htmlFor="fname" className="form-label fw-semibold">Group Name <span className="text-danger">*</span></Form.Label>
                            <Form.Control type="text" className="form-control" id="fname" placeholder="e.g. Grade 2 Parents"
                                value={groupName} onChange={(e) => setGroupName(e.target.value)} />
                            <Form.Text className="text-muted">This is what members will see in their chat list.</Form.Text>
                        </Form.Group>
                        <Button variant="primary" className="d-block w-100 mt-3 rounded-pill py-2 fw-semibold"
                            disabled={!groupName.trim() || !croppedImage}
                            onClick={() => {
                                if (groupName != "" && croppedImage != "") {
                                    handleUpload(croppedImage)
                                } else {
                                    Swal.fire({
                                        title: 'Error!',
                                        text: 'Select group image / enter group name',
                                        icon: 'error',
                                        confirmButtonText: 'Okay'
                                    })
                                }
                            }}>
                            <i className="material-symbols-outlined align-middle me-1" style={{ fontSize: 18 }}>add</i>
                            Create Group
                        </Button>
                    </Modal.Body>
                </Modal>

                <Modal show={showCroper} onHide={handleCloseCroper} size="lg" style={{ marginTop: 100 }}>
                    <Modal.Header className="d-flex justify-content-between">
                        <h5 className="modal-title" id="post-modalLabel">Resize Profile Image </h5>
                        <button type="button" className="btn btn-secondary lh-1" onClick={handleCloseCroper} ><span className="material-symbols-outlined">close</span></button>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="d-flex align-items-center" style={{ height: "300px" }}>
                            <Cropper
                                image={imageForCrop}
                                crop={crop}
                                zoom={zoom}
                                aspect={4 / 4}
                                cropShape={"rect"}
                                onCropChange={setCrop}
                                onCropComplete={onCropComplete}
                                onZoomChange={setZoom}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="primary" className="d-block w-100 mt-3"
                            onClick={() => resizeComplete()}
                        >Crop Image</Button>
                    </Modal.Footer>
                </Modal>
            </Card>
        </>
    )
}

export default CreateNewGroup
